import { schema } from 'normalizr'
import {
  createEntitiesSelector,
  createSelectorForEntityKey,
  actionCrudCreatorsFor,
  getEntity,
} from '@infotech/lib-api-middleware'
import { ESUZ_CORE_URL } from './constants'

export const ESUZ_STATUSES_SCHEMA_NAME = `esuzStatuses`
export const URL = `${ESUZ_CORE_URL}/statuses/`

const esuzStatusesSchema = new schema.Entity(ESUZ_STATUSES_SCHEMA_NAME)
export const esuzStatusesSelector = createSelectorForEntityKey(ESUZ_STATUSES_SCHEMA_NAME)
export const esuzStatusesEntitiesSelector = createEntitiesSelector(ESUZ_STATUSES_SCHEMA_NAME)
export const esuzStatusesApiActions = actionCrudCreatorsFor(ESUZ_STATUSES_SCHEMA_NAME, URL, esuzStatusesSchema)
export const singleEsuzStatuseselector = (state, id) => getEntity(state, ESUZ_STATUSES_SCHEMA_NAME, id)
